import React from 'react'

// Components
import BannerDefault from 'components/flex/Banner/BannerDefault'
import BannerSmall from 'components/flex/Banner/BannerSmall'
import BannerSlider from 'components/flex/Banner/BannerSlider'
import BannerRight from 'components/flex/Banner/BannerRight'
import BannerBig from 'components/flex/Banner/BannerBig'

interface BannerShellProps {
  fields: any
  location?: any
}

interface BannersProps {
  [key: string]: any
}

const BannerShell: React.FC<BannerShellProps> = ({ fields, location = {} }) => {
  const banners: BannersProps = {
    default: BannerDefault,
    small: BannerSmall,
    slider: BannerSlider,
    right: BannerRight,
    big: BannerBig,
  }

  if (!fields.styletype || !banners[fields.styletype]) {
    return null
  }

  const Component = banners[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default BannerShell
